import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { SettingsService } from '@app/core/settings/settings.service';

const createLanguageParams = (language: string | undefined): string =>
  language ? `?hl=${language}` : '';

@Component({
  selector: 'app-recaptcha-info',
  imports: [
    TranslatePipe,
    NgClass,
  ],
  templateUrl: './recaptcha-info.component.html',
  host: {
    '[class.tw-mb-spacing-300]': `isDs()`,
    class: 'tw-block',
  },
})
export class RecaptchaInfoComponent {
  public variant = input<'ds' | undefined>();
  public isDs = computed(() => this.variant() === 'ds');
  private language = inject(SettingsService).settings.locale;
  protected languageParam = createLanguageParams(this.language);
  protected linkClasses = computed(() => this.isDs() ? 'hover:tw-decoration-10 hover:tw-underline tw-cursor-pointer tw-text-component-link-primary tw-text-link-md' : '');
  protected textClasses = computed(() => this.isDs() ? 'tw-text-module-auth-text-header tw-text-body-regular-md' : '');
}
